export const isRunningStandalone = () => {
    // @ts-ignore
    if (navigator.standalone) {
        //user has already installed the app
        return false;
    }
    return window.matchMedia('(display-mode: standalone)').matches;
};

export const isIosOrMac = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|mac/.test(userAgent);
};
export const isIphone = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};